import { Button, Card, Flex, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { clearCurrentUserCache, loadCurrentUser } from "../auth/currentUser";
import { call } from "../tsrpc";

const PageShell = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

const AuthCard = styled(Card)`
  width: min(440px, 100%);
`;

const MForm = styled(Form)`
  width: 100%;
`;

export default function PageLogin() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const onLogin = async (values: any) => {
    const res = await call("LoginWithUsername", {
      timestamp: Date.now(),
      data: { ...values },
    });
    if (res.isSucc) {
      localStorage.setItem("username", values.username);
      clearCurrentUserCache();
      localStorage.setItem("token", res.res.data);
      try {
        await loadCurrentUser(true);
        navigate("/control");
      } catch (error: any) {
        localStorage.removeItem("token");
        clearCurrentUserCache();
        messageApi.error(error?.message || "登录身份读取失败");
      }
    } else if (res.err.code === 0x0005) messageApi.error("等待管理员审核");
    else messageApi.error(res.err.message);
  };

  return (
    <PageShell>
      {contextHolder}
      <AuthCard title="登录">
        <MForm
          name="login"
          labelCol={{ span: 6 }}
          labelAlign="left"
          initialValues={{ username: localStorage.getItem("username") }}
          onFinish={onLogin}
        >
          <Form.Item
            name="username"
            label="用户名"
            rules={[
              { required: true, message: "请输入用户名！" },
              { pattern: /^[a-zA-Z0-9_-]{4,20}$/, message: "用户名格式错误！" },
            ]}
          >
            <Input allowClear maxLength={20} showCount />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: "请输入密码！" },
              { pattern: /^[a-zA-Z0-9_-]{6,20}$/, message: "密码格式错误！" },
            ]}
          >
            <Input.Password allowClear />
          </Form.Item>
          <Form.Item>
            <Flex gap={10}>
              <Button onClick={() => navigate("/register")}>注册</Button>
              <Button type="primary" htmlType="submit" block>
                登录
              </Button>
            </Flex>
          </Form.Item>
        </MForm>
      </AuthCard>
    </PageShell>
  );
}
